import { MaterialInput } from 'app/components';
import { Container, IAppState } from 'app/containers/Container'
import { ResourceAction } from 'app/redux/Resources/actions';
import { UserActions } from 'app/redux/User/actions'
import * as React from 'react'
import { Alert, Button, Col, FormGroup, Panel, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom';

interface IUserLoginState {
  isLoggedIn: boolean
  username: string
  token: string
  error: string
  redirectAfterLogin: boolean,
  fileName: string
}

class UserLogin extends Container<{}, IUserLoginState> {
  state = {
    isLoggedIn: false,
    redirectAfterLogin: false,
    username: '',
    token: '',
    fileName: '',
    error: null
  }

  componentWillMount() {
    super.componentWillMount()
  }

  mapAppStateToContainerState(appState: IAppState) {
    const isLoggedIn = !!appState.User.username
    const { username, token, error } = this.state

    return { isLoggedIn, username, token, error, redirectAfterLogin: false, fileName: '' }
  }

  login(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    this.setState({ 'fileName': this.getParameterByName('fileName', location.href) })

    UserActions.login(this.state.username, this.state.token)
      .then(() => {
        const fileName = this.state.fileName
        if (fileName) {
          ResourceAction.getFileUrl(this.state.username, this.getState().User.token, fileName)
            .then((response) => {
              window.open(response.resource.url)
            })
            .catch((error) => {
              // tslint:disable-next-line:no-console
              console.log(error)
            })
        } else {
          location.hash = '#/'
        }
      })
      .catch((error) => this.setState({ error }))
  }

  getParameterByName(name, url) {
    if (!url) { url = window.location.href }
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    const results = regex.exec(url)
    if (!results) { return null }
    if (!results[2]) { return '' }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  setPartialState(attr: string, value: any) {
    const updateState = {}
    updateState[attr] = value

    this.state.error = null

    this.setState(updateState)
  }

  render() {
    return (
      <section>

        <section className="container padding-top-lg">
          <Row>
            <Col mdOffset={3} md={6}>
              <h6>
                To login into your account fill in the fields below
              </h6>
              <Panel className="animated fadeIn">
                <form name="loginForm" onSubmit={(e) => this.login(e)}>
                  <FormGroup>
                    <MaterialInput placeholder="Email/Username"
                      required={true}
                      onChange={(value) => this.setPartialState('username', value)}
                      value={this.state.username} />
                  </FormGroup>
                  <FormGroup>
                    <MaterialInput placeholder="Password"
                      required={true}
                      onChange={(value) => this.setPartialState('token', value)}
                      value={this.state.token}
                      type="password" />
                  </FormGroup>
                  <FormGroup>
                    <Button type="submit" bsStyle="success">
                      Login
                    </Button>
                  </FormGroup>

                  {this.state.error ?
                    <FormGroup>
                      <Alert bsStyle="danger" className="animated fadeIn">
                        <strong>
                          <i className="fa fa-fw fa-exclamation-circle" />
                          Uh oh!
                        </strong>
                        <span>
                          &nbsp;Email and/or password are incorrect. Please try again or contact the support team.
                        </span>
                      </Alert>
                    </FormGroup>
                    : null
                  }
                </form>
              </Panel>
              <h6>
                <span>Don't have an account?&nbsp;</span>
                <Link to="/register">Register here!</Link>
              </h6>
            </Col>
          </Row>
        </section>
      </section>
    )
  }
}

export {
  UserLogin
}



// WEBPACK FOOTER //
// ./src/app/containers/UserLogin/index.tsx